// import mixpanel from 'mixpanel-browser';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

ReactGA.initialize('UA-46358046-5', { debug: false /*document.location.host.includes('localhost')*/ });

let envCheck = process.env.NODE_ENV === 'production';
envCheck = true;
let trackFacebook = false;

let actions = {
	identify: (id) => {
		if (envCheck)
			ReactGA.set({ user_id: id });
		ReactGA.set({ userId: id });
	},
	alias: (id) => {
		// if (envCheck) mixpanel.alias(id);
	},
	track: (name, props) => {
		if (envCheck)
			ReactGA.event({
				category: name,
				action: props ? JSON.stringify(props) : ''
			});
	},
	setDimension: (name, value) => {
		ReactGA.set({ [name]: value });

	},
	trackPage: (pathname) => {
		setTimeout(() => {

			try {
				let pageName = pathname.replace(/\//, '');
				if (pageName === '') {
					pageName = 'home';
				}

				setTimeout(() => {
					ReactGA.pageview(window.location.pathname + window.location.search);

					// Analytics.track(`${ pageName }-loaded`);
				}, 500);

			} catch (e) {
			}
		}, 500);
	},
	people: {
		set: (props) => {
			// if (envCheck) mixpanel.people.set(props);
		},
	},
	setFacebookPixel(pixelId) {
		if (envCheck) {
			trackFacebook = true;
			ReactPixel.init(pixelId);
		}
	},
	trackFacebookEvent(event, data) {
		if (envCheck && trackFacebook) {
			ReactPixel.track(event, data);
		}
	}
};

export const Analytics = actions;
